import CalendarEmpty from './CalendarEmpty';
import Care from './Care';
import ChatEmpty from './ChatEmpty';
import Confetti from './Confetti';
import Happy from './Happy';

export const animatedIcons = {
  CalendarEmpty,
  Care,
  ChatEmpty,
  Confetti,
  Happy
};
